import styled from 'styled-components'

export const HintContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  line-height: 21px;
  padding: 4px 16px 24px 16px;
`

export const GotItBtnContainer = styled.div`
  margin: 0 auto 40px;
`
export const WrapperForCloseBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const SetReachHintModalHeader = styled.div`
  padding: 16px;
  text-align: right;
`

export const SetReachHintModalHeaderBtn = styled.button`
  background: none;
`
